/* The published article slugs, as a plain constant a CLIENT bundle can import.
   Pinned to content/articles/ by slugs.test.ts — adding an article without
   adding it here fails the build.

   WHY THIS EXISTS AT ALL, given articles.ts can already list them: articles.ts
   reads the filesystem, so it is server-only and can never reach the analytics
   layer, which runs in the browser (lib/gtag.ts is 'use client'). This is the
   same shape as KNOWN_ROUTES in lib/web-vitals-route.ts — a hand-held list whose
   test is what makes it trustworthy — and it exists for the same reason.

   WHY AN ALLOWLIST RATHER THAN A LENGTH RULE. normalizeVitalsRoute bounds
   segments by shape and length, and for this route that protection ran exactly
   backwards. Measured against production 2026-09-15:

     /articles/nope-not-a-real-article      -> page_view dl=/articles/nope-not-a-real-article
     /articles/the-anatomy-of-a-skill-file  -> page_view dl=/articles/:id

   The 404 renders inside the (marketing) layout and fires a page_view like any
   other page, and a 23-character junk slug sits under the 24-character cap, so
   invented paths passed through verbatim while the one real article was the
   thing that got collapsed. Any length rule is satisfiable by an attacker or a
   scanner; only a closed set is not. Membership here is therefore both what
   earns an article its own row in GA4 and what keeps everything else — 404s,
   scanners, stale links — in the single `/articles/:id` bucket. */

export const ARTICLE_SLUGS: ReadonlySet<string> = new Set([
  'the-anatomy-of-a-skill-file',
  'mcps-for-accounting-firms',
  'building-a-check-splitter',
  'client-data-and-ai',
])
